import { useEffect, useRef, useState } from "react"
import { Medidas } from "./data/utils"

// Mide el contenedor de las tarjetas; con esto se calcula la escala y cuántas caben por página.
export function useCardArea<T extends HTMLElement = HTMLDivElement>() {
    const ref = useRef<T>(null)
    const [area, setArea] = useState<Medidas>({ width: 0, height: 0 })

    useEffect(() => {
        const element = ref.current
        if (!element) return

        let timer: ReturnType<typeof setTimeout> | undefined = undefined
        let medido = false
        const observer = new ResizeObserver(([entry]) => {
            const { width, height } = entry.contentRect
            const actualizar = () =>
                setArea((prev) => (prev.width === width && prev.height === height ? prev : { width, height }))

            clearTimeout(timer)
            // La primera medición se aplica de inmediato; las de un resize esperan igual que `useDimensions`.
            if (!medido) {
                medido = true
                actualizar()
            } else {
                timer = setTimeout(actualizar, 150)
            }
        })

        observer.observe(element)
        return () => {
            clearTimeout(timer)
            observer.disconnect()
        }
    }, [])

    return { ref, area }
}
